export default __webpack_public_path__ + "static/media/CL03.1.cd0a6ff7.mp3";